import { FormControl, FormGroup } from "@angular/forms";

export interface DCForm {
    dcId: number | null;
    dcCode: string | null
    dcName: string | null;
    grnNumber: string | null;
    poNumber: string | null;
    warehouseAlignmentCode: string | null;
    warehouseArea: string | null;
    warehouseRotation: string | null;
    wmSystem: string | null;
    emailID: string | null;
    address: string | null;
    mainPhone: string | null;
    contactNumber: string | null;
    managerNumber: string | null;
    managerContact: string | null;
    city: string | null;
    stateProvinceRegion: string | null;
    postalCode: string | null;
    country: string | null;
    storageCapacityInSqft: number | null;
    operatingHours: string | null;
    shippingMethods: string | null;
    receivingHours: string | null;
    managerName: string | null;
    storageCapacity: string | null;
    numberOfDocks: string | null;
    facilitySize: string | null;
    automationLevel: string | null;
    energyManagement: string | null;
    zoneDetails: string | null;
    loadingDockInfo: string | null;
    safetyEquipment: string | null;
    complianceCertifications: string | null;
    materialHandlingEquipment: string | null;
    technologyInfrastructure: string | null;
    maintenanceSchedule: string | null;
    inventoryAccuracyRate: string | null;
    inventoryTypes: any | null;
    productCategory: string | null;
    specializedStorageAreas: string | null;
    keyShippingRoutes: string | null;
    preferredCarriers: string | null;
    shippingFrequency: string | null;
    leadTime: string | null;
    skusManaged: string | null;
    allowedTimeInWarehouseDays: string | null;
    [key:string]:any
  }
  
  export const DefaultDC = {
    dcId: null,
    dcCode: null,
    dcName: null,
    grnNumber: null,
    poNumber: null,
    warehouseAlignmentCode: null,
    warehouseArea: null,
    warehouseRotation: null,
    wmSystem: null,
    emailID: null,
    address: null,
    mainPhone: null,
    contactNumber: null,
    managerNumber: null,
    managerContact: null,
    city: null,
    stateProvinceRegion: null,
    postalCode: null,
    country: null,
    storageCapacityInSqft: null,
    operatingHours: null,
    shippingMethods: null,
    receivingHours: null,
    managerName: null,
    storageCapacity: null,
    numberOfDocks: null,
    facilitySize: null,
    automationLevel: null,
    energyManagement: null,
    zoneDetails: null,
    loadingDockInfo: null,
    safetyEquipment: null,
    complianceCertifications: null,
    materialHandlingEquipment: null,
    technologyInfrastructure: null,
    maintenanceSchedule: null,
    inventoryAccuracyRate: null,
    inventoryTypes: null,
    productCategory: null,
    specializedStorageAreas: null,
    keyShippingRoutes: null,
    preferredCarriers: null,
    shippingFrequency: null,
    leadTime: null,
    skusManaged: null,
    allowedTimeInWarehouseDays: null,
  }

  export type DCFormGroup = FormGroup<{ [K in keyof DCForm]: FormControl<DCForm[K]> }>;